<template>
  <mdb-modal :show="show" @close="close()" size="sm">
    <mdb-modal-header class="aqua-gradient"/>
    <mdb-modal-body class="overflow-hidden d-flex">
      <mdb-container>
        <p>{{ question }}</p>
      </mdb-container>
    </mdb-modal-body>
    <mdb-modal-footer>
      <mdb-btn-group>
        <mdb-btn
          rounded
          size="sm"
          gradient="aqua"
          @click.native="close(true)"
          title="Confirm"
          icon="check"
        >Yes</mdb-btn>
        <mdb-btn
          rounded
          size="sm"
          gradient="sunny-morning"
          @click.native="close(false)"
          title="Reject"
          icon="times"
        >No</mdb-btn>
      </mdb-btn-group>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbContainer,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtnGroup,
  mdbBtn
} from 'mdbvue'

export default {
  name: 'ConfirmationModal',
  data () {
    return {
      question: null,
      show: false,
      callback: select => { console.log('Answer selected: ', select ? 'True' : 'False') }
    }
  },
  methods: {
    close (select = false) {
      this.show = false
      this.callback(select)
      this.callback = select => { console.log('Answer selected: ', select ? 'True' : 'False') }
    }
  },
  mounted () {
    this.$bus.$on('modal-confirmation', ({question, callback}) => {
      this.callback = callback
      this.question = question
      this.show = true
    })
  },
  beforeDestroy () {
    this.$bus.$off('modal-confirmation')
  },
  components: {
    mdbContainer,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtnGroup,
    mdbBtn
  }
}
</script>

<style lang="sass">
.modal-body
  max-height: 50vh
</style>



// WEBPACK FOOTER //
// src/components/ConfirmationModal.vue